export enum ExceptionSeverity {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  FATAL = 'fatal',
  DEBUG = 'debug'
} 